import { render, staticRenderFns } from "./CampaignListTable.vue?vue&type=template&id=4e5a5133&scoped=true"
import script from "./CampaignListTable.vue?vue&type=script&lang=js"
export * from "./CampaignListTable.vue?vue&type=script&lang=js"
import style0 from "./CampaignListTable.vue?vue&type=style&index=0&id=4e5a5133&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5a5133",
  null
  
)

export default component.exports